import styled from "styled-components"
import { motion } from "framer-motion"

export const StyledSlide = styled(motion.div)`
  width: 100%;
  max-width: 948px;
  margin: 0 auto;
  position: relative;
  padding: 0 8px;
`
